import {
  CourseDto,
  ICourse,
  IUser,
  UserDto,
  SearchDto,
  ISearch,
  ExamDto,
  IExam,
  PaginationTable,
  AuditDto,
  IAudit,
  auditStatus,
} from '@shared';

const normalizeCourses = (course: CourseDto): ICourse => ({
  uuid: course.courseUuid,
  ...course,
});

const normalizeUsers = ({
  firstName,
  lastName,
  email,
  courseName,
  examName,
  sessionStartDate,
  sessionEndDate,
  duration,
  sessionStatus,
  sessionUuid,
  auditOfInterest,
  partnerUuid,
}: UserDto): IUser => ({
  uuid: sessionUuid,
  partnerUuid,
  name: `${firstName} ${lastName}`,
  email,
  courseName,
  examName,
  sessionStartDate,
  sessionEndDate,
  duration,
  sessionStatus,
  sessionUuid,
  auditOfInterest,
});

const normalizeExams = (exam: ExamDto): IExam => ({
  uuid: exam.examUuid,
  ...exam,
});

const normalizeAudits = ({
  partnerName,
  userName,
  userEmail,
  courseName,
  examName,
  examStart,
  examEnd,
  duration,
  status,
  ...rest
}: AuditDto): IAudit => ({
  uuid: rest.sessionUuid,
  partnerName,
  userName,
  userEmail,
  courseName,
  examName,
  examStart,
  examEnd,
  duration,
  status: auditStatus[status as keyof typeof auditStatus],
  ...rest,
});

export const normalizeSearch = ({ users, courses, exams, audits, ...rest }: SearchDto): ISearch => {
  return {
    users: users.map(normalizeUsers),
    courses: courses.map(normalizeCourses),
    exams: exams.map(normalizeExams),
    audits: audits?.map(normalizeAudits) ?? [],
    ...rest,
  };
};

export const tabs: PaginationTable[] = [
  PaginationTable.USERS,
  PaginationTable.COURSES,
  PaginationTable.EXAMS,
  PaginationTable.AUDITS,
];

export const getCountPages = (data: number, limit = 20) => Math.ceil(data / limit);
